<template>
    <div>
        <div class="card-body">
            <div class="card-text">
                <b-row>
                    <b-col cols="12">
                        <app-form-select-input
                            label="Tipo de herramienta"
                            :options="totalItemTypes"
                            @change="onItemTypeChange"
                            v-model="theItem.itemTypeId"
                            :required="true"
                            :has-error="$v.theItem.itemTypeId.$error"
                            error-message="Debe diligenciar el campo adecuadamente"
                        />
                    </b-col>
                    <b-col class="col-sm-6" v-if="hasField('sub-tipo')">
                        <app-form-select-input
                            label="Subtipo de herramienta"
                            :options="totalItemSubTypes"
                            @change="onItemSubTypeChange"
                            v-model="theItem.itemSubTypeId"
                            :required="true"
                            :hasError="$v.theItem.itemSubTypeId.$error"
                            errorMessage="Debe diligenciar el campo adecuadamente"
                        />
                    </b-col>
                    <b-col class="col-sm-6" v-if="hasField('marca')">
                        <app-form-select-input
                            v-model="theItem.itemBrandId"
                            :options="totalBrands"
                            label="Marca"
                            :required="hasField('marca')"
                            @change="onBrandChange"
                            :has-error="$v.theItem.itemBrandId.$error"
                            error-message="Debe diligenciar el campo adecuadamente"
                        ></app-form-select-input>
                    </b-col>
                    <b-col class="col-sm-6" v-if="hasField('serial')">
                        <app-form-text-input
                            label="Serial"
                            v-model="theItem.serial"
                            :required="true"
                            :hasError="$v.theItem.serial.$error"
                            errorMessage="Debe diligenciar el campo adecuadamente"
                            @input="$v.theItem.serial.$touch()"
                        />
                    </b-col>
                    <b-col
                        class="col-sm-6"
                        v-if="simCardRequired"
                    >
                        <app-form-text-input
                            label="No. Sim Card"
                            v-model="theItem.simCardNumber"
                            :required="simCardRequired"
                            @input="$v.theItem.simCardNumber.$touch()"
                            :has-error="$v.theItem.simCardNumber.$error"
                            error-message="Debe diligenciar el número de la sim card"
                        />
                    </b-col>
                    <b-col class="col-sm-6" v-if="hasField('precio-de-compra')">
                        <app-form-text-input
                            label="Precio de compra"
                            v-model="theItem.price"
                            :required="true"
                            :hasError="$v.theItem.price.$error"
                            errorMessage="Debe escribir el precio"
                            @input="$v.theItem.price.$touch()"
                        />
                    </b-col>
                    <b-col
                        class="col-sm-6"
                        v-if="hasField('cantidad-de-municion')"
                    >
                        <app-form-text-input
                            label="Cantidad de munición"
                            v-model="theItem.munition"
                            required
                            @input="$v.theItem.munition.$touch()"
                            :has-error="$v.theItem.munition.$error"
                            error-message="Debe diligenciar el campo adecuadamente"
                        />
                    </b-col>
                    <b-col cols="12">
                        <app-autocomplete
                            :items="clients"
                            v-model="theItem.clientId"
                            label="Cliente"
                            :get-object="false"
                            @change="onClientChange"
                        />
                    </b-col>
                    <b-col cols="12">
                        <app-form-select-input
                            :options="workplaces"
                            v-model="theItem.structureId"
                            label="Puesto"
                        />
                    </b-col>
                    <b-col class="col-sm-12" v-if="hasField('observaciones')">
                        <app-form-textarea-input
                            v-model="theItem.notes"
                            label="Observaciones"
                        >
                        </app-form-textarea-input>
                    </b-col>
                </b-row>
            </div>
        </div>
        <!-- Formulario de creacion de tipos de item -->
        <b-modal
            id="item-type-form-window"
            title="Formulario de tipo de item"
            cancel-title="Cancelar"
            ok-title="Crear"
            @ok.prevent="$refs['item-type-form'].save()"
        >
            <app-item-type-form
                ref="item-type-form"
                @created="onItemTypeCreated"
            ></app-item-type-form>
        </b-modal>
        <!-- /Formulario de creacion de tipos de item -->
        <!-- Formulario de creacion de sub tipos de item -->
        <b-modal
            id="item-sub-type-form-window"
            title="Formulario de Subtipo de item"
            cancel-title="Cancelar"
            ok-title="Crear"
            @ok.prevent="$refs['item-sub-type-form'].save()"
        >
            <app-item-sub-type-form
                ref="item-sub-type-form"
                @created="onItemSubTypeCreated"
                :itemType="itemType"
            ></app-item-sub-type-form>
        </b-modal>
        <!-- /Formulario de creacion de sub tipos de item -->
        <!-- Formulario de creacion de sub marcas -->
        <b-modal
            id="item-brand-form-window"
            title="Formulario de Marcas de items"
            cancel-title="Cancelar"
            ok-title="Crear"
            @ok.prevent="$refs['item-brand-form'].save()"
        >
            <app-item-brand-form
                ref="item-brand-form"
                @created="onItemBrandCreated"
                :itemType="itemType"
            ></app-item-brand-form>
        </b-modal>
        <!-- /Formulario de creacion de marcas -->
    </div>
</template>
<script>
import itemsRepository from '../../../../repositories/items.repository'
import appFormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue'
import appFormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue'
import appFormTextareaInput from '../../../UI/Controls/Forms/FormTextareaInput.vue'
import appDateTimePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import {
    required,
    numeric,
    requiredIf,
    minLength,
    maxLength,
} from 'vuelidate/lib/validators'
import appItemTypeForm from '../../ItemTypes/ItemTypeForm/ItemTypeForm'
import appItemSubTypeForm from '../../ItemSubTypes/ItemSubTypeForm/ItemSubTypeForm'
import appItemBrandForm from '../../ItemBrands/ItemBrandForm'
export default {
    components: {
        appFormTextInput,
        appFormSelectInput,
        appFormTextareaInput,
        appDateTimePicker,
        appItemTypeForm,
        appItemSubTypeForm,
        appItemBrandForm,
    },

    props: {
        myItem: {
            default: null,
        },
        onSave: {
            type: Function,
        },
        itemTypes: {
            type: Array,
            required: true,
        },
    },

    data: () => ({
        itemSubTypes: [],
        theItem: {
            clientId: '',
            itemBrandId: '',
            itemSubTypeId: '',
            itemTypeId: 0,
            munition: '',
            notes: '',
            price: '',
            serial: '',
            simCardNumber: '',
            structureId: '',
        },
        brands: [],
        clients: [],
        workplaces: [],
    }),
    validations: {
        theItem: {
            itemTypeId: { required },
            itemSubTypeId: {
                required: requiredIf(function() {
                    return this.hasField('sub-tipo')
                }),
            },
            serial: {
                required: requiredIf(function() {
                    return this.hasField('serial')
                }),
            },
            itemBrandId: {
                required: requiredIf(function() {
                    return this.hasField('marca')
                }),
            },
            munition: {
                required: requiredIf(function() {
                    return this.hasField('cantidad-de-municion')
                }),
                numeric,
            },
            price: {
                required: requiredIf(function() {
                    return this.hasField('precio')
                }),
                numeric,
            },
            simCardNumber: {
                required: requiredIf(function() {
                    return this.simCardRequired
                }),
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
        },
    },

    watch: {
        myItem(val) {
            this.fillForm()
        },
    },
    computed: {
        fields() {
            const itemType = this.itemTypes.find(
                item => item.id === this.theItem.itemTypeId
            )
            return !!itemType ? itemType.fields : []
        },
        simCardRequired() {
            if (!this.theItem.itemSubTypeId) return false

            const subType = this.itemSubTypes.find(
                item => item.id === this.theItem.itemSubTypeId
            )

            return ['celular', 'tablet'].includes(subType.slug.toLowerCase())
        },
        totalItemTypes() {
            return this.userCan('create-item-types')
                ? [...this.itemTypes, { id: -1, name: 'Otro', slug: 'otro' }]
                : this.itemTypes
        },
        totalItemSubTypes() {
            return this.userCan('create-item-subtypes')
                ? [...this.itemSubTypes, { id: -1, name: 'Otro', slug: 'otro' }]
                : this.itemSubTypes
        },
        totalBrands() {
            return this.userCan('create-item-brands')
                ? [...this.brands, { id: -1, name: 'Otra' }]
                : this.brands
        },
        itemType() {
            if (!this.theItem.itemTypeId) return null

            return this.itemTypes.find(
                item => item.id === this.theItem.itemTypeId
            )
        },
    },
    methods: {
        onItemTypeCreated(itemType) {
            this.itemTypes.push(itemType)
            this.theItem.itemTypeId = itemType.id
            this.closeModal('item-type-form-window')
        },
        onItemSubTypeCreated(itemSubType) {
            this.itemSubTypes.push(itemSubType)
            this.theItem.itemSubTypeId = itemSubType.id
            this.closeModal('item-sub-type-form-window')
        },
        onItemBrandCreated(brand) {
            this.brands.push(brand)
            this.theItem.itemBrandId = brand.id
            this.closeModal('item-brand-form-window')
        },
        hasField(slug) {
            return !!this.fields.find(item => item.slug === slug)
        },
        async onItemTypeChange(itemTypeId) {
            this.$v.theItem.itemTypeId.$touch()
            if (!itemTypeId) return

            this.$v.theItem.itemSubTypeId.$reset()
            this.theItem.itemSubTypeId = ''

            if (itemTypeId === -1)
                return this.openModal('item-type-form-window')

            this.loadSubTypes(itemTypeId)
            this.loadBrands(itemTypeId)
        },
        async loadSubTypes(itemTypeId) {
            const { data } = await repo.get('item-sub-types', { itemTypeId })
            this.itemSubTypes = data
        },
        async loadBrands(itemTypeId) {
            const { data } = await repo.get('item-brands', { itemTypeId })
            this.brands = data
        },
        async save() {
            const _v = this.$v
            _v.$touch()

            if (_v.$invalid)
                return toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )

            const { data } = await repo.post('items', this.theItem)

            if (data.status) {
                toastr.success('Item creado correctamente')
                this.$emit('created', data.result)
            } else {
                toastr.error(data.msg)
            }
        },
        updateItem(id) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const ir = Object.assign({}, itemsRepository)
            ir.updateItem(this.theItem, this.myItem.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        Object.keys(this.theItem).map(
                            key => (this.theItem[key] = '')
                        )
                        this.$v.$reset()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al actualizar el tipo de herramienta'
                    )
                })
        },
        saveOrUpdate() {
            if (!!this.myItem) {
                this.updateItem()
            } else {
                this.saveItem()
            }
        },
        fillForm() {
            if (Object.keys(this.myItem).length !== 0) {
                !!this.myItem.item_sub_type &&
                    (this.type = this.myItem.item_sub_type.item_type_id)
                this.theItem.subTypeId = this.myItem.item_sub_type_id
                this.theItem.name = this.myItem.name
                this.theItem.description = this.myItem.description
                this.theItem.sku = this.myItem.sku
                this.theItem.brand = this.myItem.brand
                this.theItem.reference = this.myItem.reference
                this.theItem.purchaseDate = this.myItem.purchase_date
                this.theItem.price = this.myItem.price + ''
            } else {
                this.cleanFields()
            }
        },
        cleanFields() {
            Object.keys(this.theItem).map(key => (this.theItem[key] = ''))
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.type = ''
            this.$bus.$emit('purchase-date.clear')
        },
        onItemSubTypeChange(val) {
            this.$v.theItem.itemSubTypeId.$touch()
            if (!val) return

            if (val === -1) this.openModal('item-sub-type-form-window')
        },
        onBrandChange(val) {
            this.$v.theItem.itemBrandId.$touch()
            if (!val) return
            if (-1 === val) this.openModal('item-brand-form-window')
        },
        async loadClients() {
            const { data } = await repo.get('resources/clients')
            this.clients = data
        },
        onClientChange(clientId) {
            this.loadWorkplaces(clientId)
        },
        async loadWorkplaces(clientId) {
            const { data } = await repo.get('resources/workplaces', {
                clientId,
                with: 'venue',
            })
            this.workplaces = data.map(item => ({
                ...item,
                name: `${item.name} (${item.venue.name})`,
            }))
        },
    },

    created() {
        this.$bus.$on('item-form.save', this.saveOrUpdate)
        this.$bus.$on('item-form.clean', this.cleanFields)
    },
    mounted() {
        this.loadClients()
    },
    beforeDestroy() {
        this.$bus.$off('item-form.save')
    },
}
</script>
